export default __webpack_public_path__ + "static/media/070_boost.av1.85b685c3.mp4";